import { gql, useMutation, useQuery } from '@apollo/client'

import {
  DeletePaymentSourceMutation,
  DeletePaymentSourceMutationVariables,
  PaymentDetailFragmentDoc,
  PaymentDetailQuery,
  PaymentDetailQueryVariables,
} from '@/clients/utoniq-core/schema'
import { makeViewModel } from '@/core/architecture'

import { Action, State } from './template'

export const useViewModel = makeViewModel<State, Action>(() => {
  const { data, loading } = useQuery<
    PaymentDetailQuery,
    PaymentDetailQueryVariables
  >(QUERY)

  const [deletePaymentSource] = useMutation<
    DeletePaymentSourceMutation,
    DeletePaymentSourceMutationVariables
  >(PAYMENT_SOURCE_DELETE)

  const paymentDetail = data?.paymentSource

  return {
    state: {
      cardNumber: paymentDetail?.last4,
      name: paymentDetail?.name || '',
      expirationDate: `${paymentDetail?.expMonth}/${paymentDetail?.expYear}`,
      visible: loading,
      brand: paymentDetail?.brand,
    },
    actions: {
      async onDeletePaymentSource() {
        await deletePaymentSource()
      },
    },
  }
})

const QUERY = gql`
  query PaymentDetail {
    paymentSource {
      ...PaymentDetail
    }
  }
  ${PaymentDetailFragmentDoc}
`

const PAYMENT_SOURCE_DELETE = gql`
  mutation DeletePaymentSource {
    deletePaymentSource {
      ...PaymentDetail
    }
  }
  ${PaymentDetailFragmentDoc}
`
